import { Link } from "react-router-dom";
import "../styles/components/NotFound.scss";

function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-card">
        <div className="not-found-code">404</div>

        <h1>Page not found</h1>

        <p className="not-found-message">
          The page you're looking for doesn't exist, or may have moved.
        </p>

        <div className="not-found-actions">
          <Link to="/" className="nf-btn primary">
            Back to Home
          </Link>

          <Link to="/categories" className="nf-btn ghost">
            Browse Categories
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
